import { forceTrailingSlash } from '@helpers';
// Functions used to auto-format inputs used with onBlur, onChange events

export const addSlash = (e) => {
  // add a slash to the end of the input, used with onblur
  e.target.value = forceTrailingSlash(e.target.value);
};

export const pathFormat = (e, separator = '-') => {
  let str = e.target.value;
  if (!str) {
    return;
  }
  if (str.indexOf('//')) {
    // remove doubleslashes
    str = str.replace('//', '/');
  }
  str = str.trim().toLowerCase();
  str = str.replace('_', '-');
  // Remove accents
  str = str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\œ/g, 'oe')
    .replace(/\æ/g, 'ae')
    .normalize('NFC');
  // Strip html tags
  str = str.replace(/<[^>]*>/g, '');
  str = str
    .replace(/\s+|\.+|\\+|—+|–+/g, separator)
    .replace(/[^\w0-9\/\-]+/g, '')
    .replace(/-{2,}/g, separator);
  if (!str.startsWith('/')) {
    // prefix with slash
    str = '/' + str;
  }
  e.target.value = str;
};

export const removeNewlines = (e) => {
  // remove newlines from field
  e.target.value = e.target.value.replace(/[\r\n]+/g, '');
};
// slugify value of field on change, only mutating the portion up to the cursor
const slugifyPartial = (e, separator = '-') => {
  if (!e || !e.target || typeof e.target.value !== 'string') {
    return;
  }
  const { target } = e;
  const cursor = target.selectionStart;
  // If we cannot read the cursor, fall back to full slugify to avoid changing behavior.
  if (typeof cursor !== 'number') {
    target.value = slugify(target.value, separator);
    return;
  }
  let before = target.value.slice(0, cursor);
  let after = target.value.slice(cursor);
  const formattedBefore = slugify(before, separator);
  // Avoid introducing duplicate separators across the boundary when cursor sits before one.
  if (formattedBefore.endsWith(separator) && after.startsWith(separator)) {
    after = after.slice(1);
  }
  target.value = `${formattedBefore}${after}`;
  if (typeof target.setSelectionRange === 'function') {
    const newPos = formattedBefore.length;
    target.setSelectionRange(newPos, newPos);
  }
};

// removes leading trailing separator
export const slugifyOnBlur = (e, separator = '-') => {
  e.target.value = e.target.value.replace(
    new RegExp(`^\\${separator}|\\${separator}$`, 'g'),
    '',
  );
};

export const slugify = (str, separator = '-') => {
  // Preserve separators as user types
  str = str.trim().toLowerCase();

  if (separator == '-') {
    str = str.replace(/'_'/g, '-');
  } else if (separator == '_') {
    str = str.replace(/-/g, '_');
  }
  // Remove accents
  str = str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\œ/g, 'oe')
    .replace(/\æ/g, 'ae')
    .normalize('NFC');
  // Strip html tags
  str = str.replace(/<[^>]*>/g, '');
  str = str
    .replace(/[^a-z0-9\-_]+/gi, separator) // Convert unwanted characters to separator
    .replace(new RegExp(`\\${separator}{2,}`, 'g'), separator); // Avoid consecutive separators
  return str;
};

export const slugifyDash = (e) => {
  // slugify value of field on change, only mutating the portion up to the cursor
  slugifyPartial(e, '-');
};

export const slugifyUnderscore = (e) => {
  // slugify value of field on change or blur
  // e.target.value = slugify(e.target.value, '_');
  slugifyPartial(e, '_');
};

export const urlFormat = (e) => {
  // No spaces
  // Should start with '/', 'http://', or 'https://', or $
  // If not insert 'https://'
  e.target.value = e.target.value.replace(/\s+/g, '');
  if (
    !e.target.value.startsWith('/') &&
    !'http://'.startsWith(e.target.value.slice(0, 6)) &&
    !'https://'.startsWith(e.target.value.slice(0, 7)) &&
    !'${'.startsWith(e.target.value.slice(0, 2))
  ) {
    e.target.value = `https://${e.target.value}`;
  }
};
